module.exports = __webpack_public_path__ + "img/cerifi4.c05da434.png";